import { render, staticRenderFns } from "./SelectPlatformECName.vue?vue&type=template&id=4aed681e&scoped=true&"
import script from "./SelectPlatformECName.vue?vue&type=script&lang=js&"
export * from "./SelectPlatformECName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aed681e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
